export function isWeChat() {
  var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
  return ua.match(/MicroMessenger/i) == "micromessenger" && ua.indexOf('wxwork')<0
}
export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

  if (arr = document.cookie.match(reg))

    return unescape(arr[2]);
  else
    return null;
}
export function setCookie(name, value, exdays) {
  var Days = exdays || 30
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + value + ";expires=" + exp.toGMTString()+ ";path=/";
}
export function delCookie(name) {
  setCookie(name, "", -1);
}
import wechat from '@/api/wechat'
export  async function pay( payobj,type,oid,fid){
  //使用微信支付
  wechat.wxPay({
    timeStamp: payobj.timestamp,
    nonceStr: payobj.nonceStr,
    package1: payobj.prepayId,
    signType: payobj.signType,
    paySign: payobj.paySign,
  },type,oid,fid)

}

export function setTitle(title) {
  var body = document.getElementsByTagName('body')[0];
  document.title = title;
  var iframe = document.createElement("iframe");
  iframe.style.display="none";
  function fn() {
    setTimeout(function () {
      iframe.removeEventListener('load', fn);
      document.body.removeChild(iframe);
    }, 0);
  }
  iframe.addEventListener('load', fn);
  document.body.appendChild(iframe);
}
import './jsencrypt'
export function paramsRsa(obj){
  let pubKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCaZnzWdLpujyWebF0q9mvGEhPrm7U8sx9WMRZP/h7cM5+Tix1+zCs1VFuLv+DLIKynRAcDwOhztGdn7T3+GBfgSYNY9dxcIb0AXcZKW5/k5w4+HpByGqiE+KaBY2MMAU084LEnihT36DS8CJXrZmVSWy//+6pVmPce2+XMuWUXOQIDAQAB"
  let str = ""
  var enc = new JSEncrypt()  // 创建加密对象实例
  var sKey = ""
  for(var i=0;i<pubKey.length;i++){
    sKey+=pubKey[i]
    if(i==63 || i==127 || i==191){
      sKey+='\n'
    }
  }
  enc.setPublicKey(sKey)//设置公钥
  str = encodeURIComponent(enc.encryptLong(JSON.stringify(obj)))
    // str = enc.decryptLong(obj);
  return str;
}
//判断设备
export function getUserAgent(){
  let u = navigator.userAgent;
  let str = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1?'Android': u.indexOf('Mac')>-1?'IOS':'web'
  return str;
}
export function getQueryString(url,name){
  let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  let r = url.match(reg);
  if(r!=null){return  unescape(r[2])}else{return null;}
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js